import {Injectable} from '@angular/core';
import {gql} from 'apollo-angular';
import {ApiService} from 'app/shared/modules/api/services/api.service';
import {DefaultMainPage} from '../../../globalTypes';
import {setDefaultMainPage, setDefaultMainPageVariables} from 'app/core/services/gql/setDefaultMainPage';
import {map} from 'rxjs/operators';

const setDefaultMainPageMutation = gql`
    mutation setDefaultMainPage($page: DefaultMainPage!) {
        setDefaultMainPage(page: $page)
    }
`;

@Injectable()
export class DefaultMainPageService {
    constructor(private api: ApiService) {}

    updateDefaultMainPage(page: DefaultMainPage) {
        return this.api
            .mutate<setDefaultMainPage, setDefaultMainPageVariables>({
                mutation: setDefaultMainPageMutation,
                variables: {
                    page,
                },
            })
            .pipe(map(r => r.setDefaultMainPage));
    }
}
